import Vue from 'vue'
import { temAcesso, temAcessoView } from '@/shared/auth/temAcesso'
import { notificationSystem } from './vue-configs/vuetoastrconfig'
import masker from '@/shared/mask/masker'

;(Vue.prototype.$moneyConfig = {
    decimal: ',',
    thousands: '.',
    prefix: 'R$ ',
    suffix: '',
    precision: 2,
    masked: false
}),
    (Vue.prototype.$temAcesso = regra => {
        return temAcesso(regra)
    })

Vue.prototype.$temAcessoView = regra => {
    return temAcessoView(regra)
}

Vue.prototype.$mask = (value, mask) => {
    return masker(value, mask)
}

Vue.prototype.$toastConfig = notificationSystem.options

Vue.prototype.$download = (data, filename, mime) => {
    var blob = new Blob([data], {
        type: mime || 'application/octet-stream'
    })
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        window.navigator.msSaveBlob(blob, filename)
    } else {
        var blobURL = window.URL.createObjectURL(blob)
        var tempLink = document.createElement('a')
        tempLink.style.display = 'none'
        tempLink.href = blobURL
        tempLink.setAttribute('download', filename)
        if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank')
        }
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
        window.URL.revokeObjectURL(blobURL)
    }
}

Vue.prototype.$cpfValido = cpf => {
    if (cpf.length > 11) {
        return false
    }

    while (cpf.length !== 11) {
        cpf = '0' + cpf
    }

    var igual = true
    for (let i = 1; i < 11 && igual; i++) {
        if (cpf[i] !== cpf[0]) {
            igual = false
        }
    }

    if (igual || cpf === '12345678909') {
        return false
    }

    var numeros = [11]

    for (let i = 0; i < 11; i++) {
        numeros[i] = parseInt(cpf[i].toString())
    }

    var soma = 0
    for (let i = 0; i < 9; i++) {
        soma += (10 - i) * numeros[i]
    }

    var resultado = soma % 11
    if (resultado === 1 || resultado === 0) {
        if (numeros[9] !== 0) {
            return false
        }
    } else {
        if (numeros[9] !== 11 - resultado) {
            return false
        }
    }

    soma = 0
    for (let i = 0; i < 10; i++) {
        soma += (11 - i) * numeros[i]
    }

    resultado = soma % 11

    if (resultado === 1 || resultado === 0) {
        if (numeros[10] !== 0) {
            return false
        }
    } else {
        if (numeros[10] !== 11 - resultado) {
            return false
        }
    }
    return true
}

Vue.prototype.$maskDate = value => {
    return value ? Vue.moment(value).format('DD/MM/YYYY') : ''
}
